import {CommentsCategory} from '@domain/comments'
import type {BaseSchedule} from '@domain/schedule'
import type {AssetSnapshot} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit'
import {Stack} from '@mui/material'
import {CommentSidebarButton, useCommentsPermissions} from '@widgets/planning-comments'
import {Moment} from 'moment-timezone'
import React from 'react'

import {PlannerFeature, usePlannerFeature} from '../hooks'

interface OperatorChartCardActionsProps {
  toggleCommentsSidebar?: () => void
  isCardCollapsed: boolean
  schedule: BaseSchedule | undefined
  assets: AssetSnapshot[] | undefined
  startOfChart: Moment
  endOfChart: Moment
}

export const OperatorChartCardActions: React.FC<OperatorChartCardActionsProps> = ({
  toggleCommentsSidebar,
  isCardCollapsed,
  schedule,
  assets,
  startOfChart,
  endOfChart
}) => {
  const areCommentsEnabled = usePlannerFeature(PlannerFeature.PlanningComments)
  const {canViewComments: canViewAssetComments} = useCommentsPermissions(CommentsCategory.Assets)
  const {canViewComments: canViewAssetOperationTimesComments} = useCommentsPermissions(
    CommentsCategory.AssetOperationTimes
  )
  const canViewComments = canViewAssetComments || canViewAssetOperationTimesComments

  const shouldShowCommentSidebarButton =
    areCommentsEnabled && canViewComments && toggleCommentsSidebar && !isCardCollapsed
  return (
    <>
      <Stack
        spacing={1.5}
        sx={{display: 'flex', alignItems: 'center'}}
        direction="row"
        {...dataTestId('planning_actions')}
      >
        {shouldShowCommentSidebarButton && (
          <CommentSidebarButton
            toggleCommentSidebar={toggleCommentsSidebar}
            schedule={schedule}
            assets={assets}
            startOfChart={startOfChart}
            endOfChart={endOfChart}
          />
        )}
      </Stack>
    </>
  )
}
